import { deserializeAssetWritingLogs } from "../entities/AssetWritingLogs";
import { deserializeWritingLog } from "../entities/WritingLog";
import { WebClient } from "./server/WebClient";

export interface WritingLogRequest {
	id?: string;
	assetId: string;
	dateCreated: Date;
	writingTimeInSeconds: number;
}

export const AssetWritingLogService = {
	getAssetWritingLogs: (assetId: string) => WebClient.Get(`api/AssetWritingLog/GetAssetWritingLog/${assetId}`, deserializeAssetWritingLogs),

	createAssetWritingLog: (request: WritingLogRequest) =>
		WebClient.Post.Validated("api/AssetWritingLog/CreateAssetWritingLog", request, deserializeWritingLog),

	updateAssetWritingLog: (request: WritingLogRequest) =>
		WebClient.Put.Validated("api/AssetWritingLog/UpdateAssetWritingLog", request, deserializeWritingLog),

	deleteAssetWritingLog: (writingLogId: string) => WebClient.Delete(`api/AssetWritingLog/DeleteAssetWritingLog/${writingLogId}`),
};
